module.exports = __webpack_public_path__ + "img/logo-2o3t.ca82c9f8.svg";